"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StepThree = function StepThree(_ref) {
  var files = _ref.files;
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "stepThree"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "display-files-uploaded flex flow-column"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "step-three-details"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-header"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "file_table_cell selected_files_header"
  }, "Selected files"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "file_table_cell category_header"
  }, "Category")), files.map(function (f) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex gap-5",
      key: "fileStepThree-".concat(f.file.name)
    }, /*#__PURE__*/_react["default"].createElement("span", {
      title: f.file.name,
      className: "text-overflow-ellipsis",
      style: {
        width: "80%"
      }
    }, f.file.name), /*#__PURE__*/_react["default"].createElement("div", {
      className: " category_header"
    }, f.fileCategory));
  }))));
};
var _default = exports["default"] = StepThree;